export const AdviseLabels = {
    HERO_TITLE: 'Bienvenido a Advise',
    HERO_MESSAGE: `Ofrecemos servicios de desarrollo de software empresarial y consultoría tecnológica, 
    diseñados para mejorar y optimizar los procesos internos de su empresa. 
    ¿Necesitas conocer cómo podemos ayudarte?`,
    STATISTICS_ANIOS_EXPERIENCIA_TITLE: 'Desde',
    STATISTICS_ANIOS_EXPERIENCIA_VALUE: 2003,
    STATISTICS_CLIENTES_TITLE: 'Clientes',
    STATISTICS_CLIENTES_VALUE: 30,
    STATISTICS_CASOS_EXITO_TITLE: 'Casos de Éxito',
    STATISTICS_CASOS_EXITO_VALUE: 200,
    STATISTICS_INTERNACIONAL_TITLE: 'Proyectos Internacionales',
    STATISTICS_INTERNACIONAL_VALUE: 7,
    US_TITLE: 'Quienes Somos',
    US_SUBTITLE: 'Sobre Nosotros',
    US_MESSAGE: `En Advise, desde nuestros inicios a principios de 2003, nos hemos dedicado a transformar 
                ideas en soluciones tecnológicas de alto impacto. Nos especializamos en ofrecer servicios 
                de desarrollo de software empresarial y consultoría tecnológica, ayudando a las empresas 
                a innovar y optimizar sus procesos con herramientas personalizadas y adaptadas a sus necesidades. 
                Con más de dos décadas de experiencia, seguimos comprometidos con la excelencia, el crecimiento 
                y la satisfacción de nuestros clientes.`,
    PROMISE_TITLE: 'Nuestra Promesa',
    PROMISE_MESSAGE: `Ofrecemos servicios profesionales de calidad enfocados en generar valor real a 
                        nuestros clientes, facilitando un retorno efectivo de la inversión y un aumento de la 
                        productividad. Nos basamos en la colaboración, estableciendo relaciones de confianza a 
                        largo plazo, trabajando con honestidad, compromiso e innovación para ayudar a nuestros 
                        clientes a alcanzar sus objetivos.`,
    CERTIFICATE_TITLE: "Nuestros Certificados",
    CERTIFICATE_40HRS: "Certificado 40 Horas",
    CERTIFICATE_SCRUM: "Certificado Scrum",
    MERCADO_PUBLICO: "Mercado Público - Licitación 2239-1-LR22",
    MONGO_CERTIFICATE: "Certificado Mongo DB SI Associtate",
    SERVICES_TITLE: "Nuestros Servicios",
    SERVICE_SOFTWARE_TITLE: "Desarrollo de Software Empresarial",
    SERVICE_SOFTWARE_DESCRIPTION: `Software empresarial, hace relación con el desarrollo de sistemas 
                                    o aplicaciones que resuelven una o varias problemáticas de negocio 
                                    de la empresa, y tiene mútiples dimensiones técnicas de que resolver 
                                    (lenguajes de programación, integración, presentación, disponibilidad, 
                                    rendimiento, etc.) Aplicamos metodologías agíles (Scrum) y 
                                    buenas prácticas de industria (Integración Continua).`,
    SERVICE_SOFTWARE_RESUME: `Creamos soluciones tecnológicas personalizadas para resolver problemáticas de negocio
                            y optimizar procesos internos empresariales.`,
    SERVICE_MANTENCION_TITLE: "Mantención y Soporte",
    SERVICE_MANTENCION_DESCRIPTION: `Corresponde a servicios de colaboración que permiten entregar 
                                    continuidad operativa y mantención evolutiva de aplicaciones 
                                    ya existentes.`,
    SERVICE_MANTENCION_RESUME: `Servicios que garantizan la continuidad operativa y el 
                                mantenimiento evolutivo de aplicaciones existentes.`,
    SERVICE_CONSULTORIA_TITLE: "Consultoría Tecnológica",
    SERVICE_CONSULTORIA_DESCRIPTION: `Nuestros servicios de consultoría aprovechan el capital intelectual
                                      que hemos generado a través del tiempo en los proyectos, rescatando 
                                      así experiencia sobre los casos de éxito y buenas prácticas.`,
    SERVICE_CONSULTORIA_RESUME: `Nuestros servicios de consultoría aprovechan la experiencia acumulada en proyectos, 
                                 aplicando casos de éxito y buenas prácticas.`,
    SERVICE_CIBERSEGURIDAD_TITLE: "Análisis de Ciberseguridad",
    SERVICE_CIBERSEGURIDAD_DESCRIPTION: `Podemos colaborar con tareas de análisis y corrección de vulnerabilidades 
                                        en base al estándar OWASP, pruebas de penetración (Pen-Test) mediante el uso
                                        de herramientas especializadas.`,
    SERVICE_CIBERSEGURIDAD_RESUME: `Colaboramos en el análisis y corrección de vulnerabilidades según el estándar 
                                    OWASP, realizando pruebas especializadas.`,
    SERVICE_SOLUCION_TITLE: "Soluciones Tecnológicas",
    SERVICE_SOLUCION_DESCRIPTION: `Disponemos de soluciones que permiten acelerar sus desarrollos, contamos con 
                                    soluciones de comercio electrónico, botones de pago, factoring electrónico, 
                                    firma digital y integración de sistemas y otros.`,
    SERVICE_SOLUCION_RESUME: `Ofrecemos soluciones e integraciones para acelerar desarrollos.`,
    SERVICE_LICENCIA_TITLE: "Licenciamiento de Software",
    SERVICE_LICENCIA_DESCRIPTION: `Nuestras alianzas como asociados de negocios, nos permiten proporcionar servicios
                                de venta de licencias y servicios de habilitación. Software IBM, Migración a la nube 
                                de Amazon y productos de seguridad.`,
    SERVICE_LICENCIA_RESUME: `Nuestras alianzas como asociados de negocios nos permiten ofrecer servicios 
                              de venta de licencias y habilitación.`,
    PRODUCTS_TITLE: "Nuestros Productos",
    PRODUCTS_PANELES_TITLE_ADVISE: "SiGGER 360",
    PRODUCTS_PANELES_TITLE_DESCRIPTION: `SiGGER 360 es una plataforma que permite gestionar y controlar 
                                        el monitoreo de paneles solares del instalador, ofreciendo principalmente 
                                        módulos de observación de detalle de plantas, facturación para los clientes 
                                        y predicciones de energía en base a estimaciones y pronósticos.`,
    PRODUCTS_CONVENIO_MARCO_TITLE: "MSA",
    PRODUCTS_CONVENIO_MARCO_DESCRIPTION: `MSA es una plataforma que permite monitorear el sitio de Convenio
                                        Marco de Desarrollo de Software y Servicios IT de Mercado Público, el producto ofrece módulos estadísticos
                                        a nivel general, organizacional o de proveedor, permite realizar seguimientos
                                        a cotizaciones de interés y obtener la misma información que ofrece el sitio original de
                                        manera más ágil.`,
    CLIENTS_TITLE: "Nuestros Clientes",
    CLIENTS_PUBLIC: "Clientes Públicos",
    CLIENTS_PRIVATE: "Clientes Privados",
    PARTNERS_TITLE: "Nuestros Partners",
    CONTACT_TITLE: "Contacto",
    CONTACT_SUBTILTE: "¿Tienes una idea en mente para tu negocio?",
    CONTACT_DESCRIPTION: `Si tienes una idea y quieres compartirla con nosotros o necesitas algún 
                          servicio, no dudes en contactarte con nosotros para entender tus necesidades
                          y obtener la solución adecuada con todo el equipo`,
    CONTACT_SEND_TITLE: "Propuesta Enviada",
    CONTACT_SEND_MESSAGE: `Muchas Gracias por enviar tu propuesta, te contactaremos dentro de poco`,
    HELP_PROGRAM: "Programa de Integridad",
    SEAL_40_HRS: "Sello 40 Horas",
    HELP_CM: "Portal MSA",

    ADVISE_SLOGAN: "Colaborando con soluciones tecnológicas a los negocios de nuestros clientes",
}